import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-hr-detail',
  templateUrl: './hr-detail.component.html',
  styleUrls: ['./hr-detail.component.scss']
})
export class HRDetailComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
